import { GridColumn } from 'api/endpoints';
import { Group } from 'components/UIComponents/GroupMultiSelect';
import { ResolutionTypeSet } from 'hooks/useResolutionExhibitTypeOptions';
import uniqueId from 'lodash/uniqueId';
import { ReviewersBatchItem } from '../../../../../components/ReviewersEdit/ReviewersEdit.utils';

interface Dictionary<T> {
  [index: string]: T;
}

export type TAllowedEnums = Dictionary<string>;
export type TAllowedMajMin = Dictionary<TAllowedEnums>;
export type TAllowedValues = TAllowedEnums | TAllowedMajMin;

type CustomBatchDataType =
  | 'maj-min'
  | 'group-multi-select'
  | 'action-name-id'
  | 'action-status';

export type TBatchDataType =
  | GridColumn['dataType']
  | CustomBatchDataType
  | undefined;

export type IBatchItem = {
  id: string;
  propName: GridColumn['propertyName'];
  type: TBatchDataType;
  allowedValues?: TAllowedValues | Group[];
  value: string | ReviewersBatchItem | ResolutionTypeSet | undefined;
};

export const emptyItem = (): IBatchItem => ({
  id: uniqueId(),
  propName: '',
  type: undefined,
  value: undefined,
});

export type IBatchEditableColumns = {
  disabled?: boolean;
  propertyName: GridColumn['propertyName'];
  displayName: GridColumn['displayName'];
  dataType: TBatchDataType;
  allowedValues?: TAllowedValues | Group[];
  defaultValue?: any;
};

export interface IBatchEditCategories {
  categories: TAllowedMajMin | undefined;
}
